import { configureHttpAuth } from '../startup/configureHttpAuth';
import { CurrentPage } from '../pages/currentPage';
import { ErrorSmallPopup } from '../popups/errorSmallPopup';
import { Localization } from '../localization/localization';

const asyncLoginCallbacks: LoginCallback[] = [];
const asyncRegistrationCallbacks: LoginCallback[] = [];
let autoreloadOnCallbacksResolved = true;

export async function handleSocialLoginSuccess(huid: number, isRegistration: boolean = false) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let callbackPromises: Promise<any>[];

    window.app.user_huid = huid;
    configureHttpAuth();
    callbackPromises = getSocialCallbacks(isRegistration);
    await Promise.all(callbackPromises);

    if (autoreloadOnCallbacksResolved) {
        CurrentPage.reload();
    }
}

export function handleSocialLoginFail() {
    const errorPopup = ErrorSmallPopup.getInstance();
    errorPopup.setMessage(Localization._n('common_error'));
    errorPopup.setButtonText('Ok');
    errorPopup.show();
    errorPopup.setCallback(() => {
        errorPopup.hide();
    });
    return true;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getSocialCallbacks(isRegistration: boolean): Promise<any>[] {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let callbackPromises: Promise<any>[];

    if (isRegistration === true) {
        callbackPromises = asyncRegistrationCallbacks.map((callback) => callback());
    } else {
        callbackPromises = asyncLoginCallbacks.map((callback) => callback());
    }

    return callbackPromises;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type LoginCallback = () => Promise<any>;

export function addLoginCallback(callback: LoginCallback) {
    asyncLoginCallbacks.push(callback);
}

export function addRegistrationCallback(callback: LoginCallback) {
    asyncRegistrationCallbacks.push(callback);
}

export function disableAutoreloadAfterLoginCallbacks() {
    autoreloadOnCallbacksResolved = false;
}

export function exposeLoginHandlerFunctions() {
    window.app.handleSocialLoginSuccess = handleSocialLoginSuccess;
    window.app.handleSocialLoginFail = handleSocialLoginFail;
}

